import { render } from "./CookieConsentBox.vue?vue&type=template&id=757e9b6c"
import script from "./CookieConsentBox.vue?vue&type=script&lang=js"
export * from "./CookieConsentBox.vue?vue&type=script&lang=js"

import "./CookieConsentBox.vue?vue&type=style&index=0&id=757e9b6c&lang=scss"

import exportComponent from "/Users/yanislav.pavlov/development/private/bulgartabac/bulgartabac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__